import React, { useState } from 'react';
import { Modal, Button, Avatar, Input } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import axiosInstance from '../../../axios'
// import { dateDisplayable } from '../../table-utils';
type DealingsCommentPopupProps = {
    id: string | number;
    valueUpdater: () => void;
}


function DealingsCommentPopup(props: DealingsCommentPopupProps) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [newComment, setNewComment] = useState('');
    const [loading, setLoading] = useState(false);

    const showModal = async () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };


    async function postNewComment(newComment: string) {
        if (!newComment)
            return;
        try {
            setLoading(true);
            const response = await axiosInstance.post(`/v1/cre/student/deal/student-comment`, {
                dealings_id: props.id,
                comment: newComment
            });
            console.log('Comment posted successfully:', response.data);
            setNewComment('');
            props.valueUpdater();
            setIsModalVisible(false);
            // await fetchCommentsArray(); // Refresh the comments array after posting a new comment
        } catch (error) {
            console.error('Error posting comment:', error);
        } finally {
            setLoading(false);
        }
    }


    return (
        <div>
            <Button type="link" size="large" className="tail-px-0 tail-underline" onClick={showModal}>Add Comment</Button>
            <Modal
                loading={loading}
                title="Comments"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="close" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="ok" type='primary' onClick={() => postNewComment(newComment)}>
                        Ok
                    </Button>,
                ]}
            >
                <div>
                    <Input placeholder='' value={newComment} onChange={(e) => setNewComment(e.target.value)} />
                </div>
            </Modal>
        </div>
    );
}

export default DealingsCommentPopup;